import React from 'react';
import { Row, Col } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { SubContainer } from '../styles';
import { FormItem } from '../../../styles';
import { Text } from '@/components/Typography';
import { useCategoryContext } from '../context';
import { useRosaContext } from '../../../../../context';
import { useUpdateElement } from '../../../../../hooks/useUpdateElement';

interface SubOptionalElementProps {
	name: string;
	score: number;
	children: string;
	disabled: boolean;
}

export function SubOptionalElement({ children, score, name, disabled }: Readonly<SubOptionalElementProps>) {
	const { organization_id, company_id, file_id } = useRosaContext();
	const { fieldName, subCategoriesElements, selectedSubCategory } = useCategoryContext();

	const { mutateAsync: updateElement } = useUpdateElement({ organization_id, company_id, report_id: file_id });

	async function handleUpdateNotRequiredElement(e: CheckboxChangeEvent) {
		const isChecked = e.target.checked;

		const selectedElement = subCategoriesElements[selectedSubCategory.name].not_required.find(
			(element: any) => element.name === name
		);

		const payload = {
			evaluation_element: {
				id: selectedElement?.id,
				checked: isChecked
			}
		};

		await updateElement(payload);
	}

	return (
		<FormItem valuePropName="checked" name={[...fieldName, 'not_required', name]}>
			<SubContainer disabled={disabled} onChange={handleUpdateNotRequiredElement}>
				<Row justify="space-around">
					<Col lg={20} xxl={22}>
						<Text>{children}</Text>
					</Col>
					<Col lg={4} xxl={2}>
						<span className="score">+{score}</span>
					</Col>
				</Row>
			</SubContainer>
		</FormItem>
	);
}
